<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <modal-form modal-id="add-user" animation="fadeInRight">
      <div slot="title">Add New User</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addUser['name']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Username</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addUser['username']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Password</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addUser['password']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Email</div>
            <div class="col-lg-9">
              <input type="email" name="" class="form-control" v-model="addUser['email']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Clients</div>
            <div class="col-lg-9">
              <v-select :options="f.clients" multiple v-model="addUser['clients']" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row" v-if="addUser['clients'].length">
            <div class="col-lg-3">Groups</div>
            <div class="col-lg-9">
              <v-select
                :options="f.groups.filter(g => addUser['clients'].includes(g.client.id))"
                multiple
                v-model="addUser['groups']"
                label="fullName"
                index="id"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Roles</div>
            <div class="col-lg-9">
              <v-select :options="userRoles" multiple v-model="addUser['roles']"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Admin</div>
            <div class="col-lg-9">
              <v-select :options="[{val: 'false', txt: 'No'}, {val: 'true', txt: 'Yes'}]" :clearable="false" label="txt" index="val" v-model="addUser['admin']"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Active</div>
            <div class="col-lg-9">
              <v-select :options="[{val: 'false', txt: 'No'}, {val: 'true', txt: 'Yes'}]" :clearable="false" label="txt" index="val" v-model="addUser['active']"></v-select>
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveUser">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Users</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-user">Add user</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Users/Filters'
import List from './Users/List'
import axios from 'axios'
import { USER_LIST_SET } from '../../../store/mutation-types'
import Modal from '../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'

// Add User Defaults
const userAddDefaults = {
  name: '',
  username: '',
  password: '',
  email: '',
  clients: [],
  roles: [],
  active: 'true',
  admin: 'false',
  operator: 1
}

export default {
  data () {
    return {
      addUser: {...userAddDefaults}
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      userRoles: 'getUserRoles'
    })
  },
  mounted () {
    document.title = 'Admin Users :: PBN360 by Aphex Media'
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  components: {
    filters: Filters,
    list: List,
    modalForm: Modal
  },
  methods: {
    saveUser () {
      const addUser = {...this.addUser}
      if (!addUser.username || !addUser.password || !addUser.email) {
        this.$toastr.error('Some data seems to be missing', 'Please try a bit harder')
        return
      }
      // Boolify
      addUser.admin = addUser.admin === 'true' ? 1 : 0
      addUser.active = addUser.active === 'true' ? 1 : 0

      axios.post('/user', addUser)
        .then(r => {
          $('#add-user').modal('hide')
          this.$store.commit(USER_LIST_SET, [...this.$store.state.userList, r.data])
          this.$toastr.success('Order added successfully', 'Brilliant stuff lad')
        })
        .catch(e => {
          const msg = e.response ? e.response.data.msg : 'Not so great is it...'
          this.$toastr.error(e, msg)
        })
      // Reset form to defaults
      Object.keys(userAddDefaults).forEach(k => {
        this.$set(this.addUser, k, userAddDefaults[k])
      })
    }
  }
}
</script>
<style>
.inactive {
  background-color: #ffdfdd;
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Users.vue